//import angular from 'angular';

const moduleName = "app.common";
export default moduleName;
angular.module(moduleName, []);
